import { useState } from "react";
import Input from "../../shared/components/Input";
import "./styles.css";
import Form from "../../shared/components/Form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
const Login = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState();

  const handleLogin = (event) => {
    event.preventDefault();
    console.log("User details on signin", user)
    if (user.email !== "petros@gmail.com") {
      toast.error("Incorrect Email Address!")
      return;
    }

    
    if (user.password !== "Petros@2025!!") {
      toast.error("Incorrect Password!")
      return;
    }
    localStorage.setItem("user-data", JSON.stringify({ authenticated: true }));

    navigate("/ems/dashboard/events");
  };

  return (
    <div className="login__wrapper">
      <div className="login__container">
        <div className="login__title">Login</div>

        <Form onSubmit={handleLogin}>
          <div className="form__row">
            <div className="form__row--item">
              <Input
                onInput={(event) => setUser({ ...user, email: event.target.value })}
                isRequired
                label="Email" />
            </div>
          </div>
          <div className="form__row">
            <div className="form__row--item">
              <Input
                onInput={(event) => setUser({ ...user, password: event.target.value })}
                isRequired
                type="password"
                label="Password" />
            </div>
          </div>
        </Form>
      </div>
    </div>
  )
};

export default Login;